import React from 'react';
import { connect } from 'react-redux';
import { Pagination, Alert } from 'react-bootstrap';

import { fetchSpecificPageTopologyData } from './../../../../actions/closeLoop/topology/index';
import PropTypes from "prop-types";


function PaginationBar(props) {
    const handleNavigatePage = (e) => {
        const pageNum = e.target.innerHTML;
        console.log("enter")
        if (props.page != pageNum) {
            const payload = {
                page : pageNum,
                perPage: 7
            };
            console.log(payload);
            props.getSpecificPageData(payload);
        }
    }
    const handlePreviousPage = (e) =>{
        let previous_page = props.page;
        console.log(previous_page)
        if(previous_page > 1){
             const payload = {
                page : previous_page - 1,
                perPage: 7
            };
            props.getSpecificPageData(payload);
        }
    }
    const handleForwardPage = (e) =>{
        let current_page = props.page;
        let last_page = props.pages
        if(current_page < last_page[last_page.length - 1]){
             const payload = {
                page : current_page + 1,
                perPage: 7
            };
            console.log(payload);
            props.getSpecificPageData(payload);
        }
    }
    const dotPageHandle=(index)=>{
        let index_page = index - 1
        let page = props.pages[index_page] + 1
        const payload = {
                page : page,
                perPage: 7
            };
            console.log(payload);
            props.getSpecificPageData(payload);
    }
    return (
        <>
            { props.pages.length === 0 ? (
                <Alert variant="info">No pages found for this component</Alert>
            ) : (
                <Pagination>
                    <Pagination.First  onClick={(e) => { handlePreviousPage(e) }}/>
                    { props.pages.map((item, index) => {
                        if(item === null) {

                            return <Pagination.Ellipsis key={index}  onClick={(e) => { dotPageHandle(index) }}/>

                        }
                        return (<Pagination.Item
                                    key={index}
                                    className={props.page === item ? "active": ""}
                                    onClick={(e) => { handleNavigatePage(e) }}
                                >
                                    { item }
                                </Pagination.Item>)
                    }) }
                    <Pagination.Last  onClick={(e) => { handleForwardPage(e) }}/>
                </Pagination>
            ) }
        </>
    )
}

const mapStateToProps = (state) => ({
    pages: state.topology.pages,
    page: state.topology.page,
});

const mapDispatchToProps = (dispatch) => ({
    getSpecificPageData: (payload) => dispatch(fetchSpecificPageTopologyData(payload))
});

PaginationBar.propTypes = {
    page: PropTypes.number,
    getSpecificPageData: PropTypes.func,
    pages: PropTypes.array,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaginationBar);